<template>
  <div class="progress">
    <div class="bar-wrap">
      <div
        class="bar"
        :style="barColor ? `background-color: ${barColor}; width: ${number}%;` : `width: ${number}%`"
      ></div>
    </div>
    <p :style="textColor ? `color: ${textColor}` : ''">{{ number }}%</p>
  </div>
</template>
<script>
import { computed } from '@vue/reactivity';
export default {
  name: 'cus-progress',
  props: {
    progress: { type: Number, default: 0 },
    textColor: { type: String, default: '' },
    barColor: { type: String, default: '' },
  },
  setup(props) {
    const number = computed(() => {
      if (props.progress > 100) return 100;
      else if (props.progress < 0) return 0;
      else return Math.floor(props.progress);
    });
    return { number };
  },
};
</script>
<style lang="scss" scoped>
.progress {
  display: grid;
  grid-template-columns: 88% auto;
  grid-gap: 16px;
  height: 30px;
  align-items: center;
  .bar-wrap {
    background-color: $color-gray-6;
    height: 12px;
    border-radius: 5px;
    .bar {
      height: 100%;
      background-color: $color-green;
      border-radius: 5px;
      transition: 0.3s;
    }
  }
  p {
    font-size: 2.2rem;
    color: $color-gray-60;
    line-height: 30px;
  }
}
</style>
